import { render } from "./TvIcon.vue?vue&type=template&id=740a3758"
import script from "./TvIcon.vue?vue&type=script&lang=js"
export * from "./TvIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__